import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { AuthLoadingScreen } from './AuthErrorScreen'

export function AdminRoute() {
  const { loading, authState, currentUser } = useAuth()
  const location = useLocation()

  if (loading || authState !== 'ready') return <AuthLoadingScreen />

  if (!currentUser?.is_admin) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />
  }

  return <Outlet />
}
